import { Component, ViewChild, ViewEncapsulation, OnInit } from "@angular/core";

import {
    CellEditInputType,
    CreateMode,
    DisplayMode,
    GridComponent,
    GridValidator,
    IGridColumn,
    IGridSettings,
    ITableSettings,
    UpdateMode
} from "@features/grid";
import { FilterInputType, FilterType } from "@features/filter";
import { RavenStatusService } from "../raven-status.service";
import { RavenApiService } from "../raven-api.service";

@Component({
    selector: "raven-status",
    templateUrl: "raven-status.component.html",
    styleUrls: []
})
export class RavenStatusComponent implements OnInit {
    tableSettings: ITableSettings = {
        lazyLoadOnInit: false
    };
    gridSettings: IGridSettings = {
        deleteAllEnabled: false,
        updateMode: UpdateMode.Disabled,
        createMode: CreateMode.Disabled,
        filtersRow: false,
        exportEnabled: false,
        deletingAvailable: (rowData => false),
    };
    @ViewChild("grid", { static: true }) grid: GridComponent;

    constructor(public ravenStatusService: RavenStatusService, public ravenApiService: RavenApiService) {
        this.gridSettings.dataService = ravenStatusService;
        this.init();
    }

    // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
    ngOnInit(): void {

    }

    check() {
        this.ravenApiService.checkStatuses().finally(() => {
            this.grid.reload();
        })
    }

    private async init(): Promise<any> {

        this.tableSettings = {
            columns: <IGridColumn[]>[
                {
                    header: "Name",
                    field: "name"
                },                
                {
                    header: "Is Closing Status",
                    field: "isClosingStatus",
                    trueConditionValue: "Yes",
                    falseConditionValue: "No",
                    editableOnCreate: false,
                    editableOnUpdate: false,
                    displayMode: DisplayMode.Conditional
                },
                {
                    header: "Record Type",
                    field: "recordType",
                    editableOnCreate: false,
                    editableOnUpdate: false
                },
            ]
        };
    }
}

